import { usePantry } from '@/features/pantry/usePantry'

/**
 * Computes badge counts for bottom/side navigation tabs.
 * Reads from existing React Query caches — no new API calls.
 *
 * - plan: unfilled slot count (null when all 7 filled or no data)
 * - pantry: "Running Low" item count (null when none)
 */
export function useTabBadges() {
  const { data: pantryItems, isLoading: pantryLoading } = usePantry()

  // Meal plan feature not yet implemented — return null for now.
  // When meal-plan hooks are added, wire in useWeeklyMealPlan here.
  const planBadge: number | null = null

  const runningLowCount =
    pantryItems?.filter((i) => i.pantryState === 'running_low').length ?? 0
  const pantryBadge = runningLowCount > 0 ? runningLowCount : null

  return {
    plan: planBadge,
    pantry: pantryBadge,
    isLoading: pantryLoading,
  }
}
